import { render } from "./CoachReportAIHelper.vue?vue&type=template&id=d224560e"
import script from "./CoachReportAIHelper.vue?vue&type=script&lang=js"
export * from "./CoachReportAIHelper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__